// @flow
import React from 'react';
import { Button } from '@elements';
import { withTranslation } from 'react-i18next';
import { createNsTranslator, useIsMobile, useDarkStatusBar } from '@helpers/helpers';
import './SubscriptionComplete.scss';

type Props = {
  t: Function,
}

const SubscriptionComplete = ({ t }: Props) => {
  const _ = createNsTranslator('subscription', t);
  // A light page at the top on phones; wider screens show the app's dark header above it
  const [isMobile, isIpad] = useIsMobile();
  useDarkStatusBar(isMobile || isIpad);

  return (
    <div id="successPage" className="appContent formPage">
      <section className="mainSection">
        <div className="centerContent">
          <div className="desktopCard">
            <span className="ccArt" />
            <h1>{_('label/credit_card/payment_success_title')}</h1>
            <p>{_('label/credit_card/payment_success_text')}</p>

            <div className="actionsFooter">
              <Button className="primary" text={_('action/payment_success_back')} linkTo="/pacientes/lista" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withTranslation()(SubscriptionComplete);
